export default {
	"transSec.SorryFailedToCreateOrder": "Sorry, failed to create order!",
	"transSec.CopiedSuccessfully": "Copied successfully!",
	"transSec.ReplicationIsNotSupported": "Replication is not supported",
	"transSec.ParameterError": "Parameter error!",
	"transSec.CongratulationsOnYourSuccessfulUpgrade": "Congratulations on your successful upgrade",
	"transSec.CallItOfficial": "Call it official",
	"transSec.UpgradeContent": "Upgrade content:",
	"transSec.UpgradeType": "Upgrade Type:",
	"transSec.SubscriptionsArePaidAnnually": "Subscriptions are paid annually",
	"transSec.TheAmountOfTheItem": "The amount of the item",
	"transSec.SubscriptionPaidIn": "Subscription paid-in",
	"transSec.UpgradeOffers": "Upgrade offers",
	"transSec.expenses": "expenses",
	"transSec.AfterTheUpgradeIsSuccessfulYouCanViewYourUpgradeInformationInTheFirstOrderOfTheSubscriptionAtTheSameTimeTheAutomaticDeductionOfTheOriginalSubscriptionWillBeAutomaticallyTerminatedThroughTheSystemAndWillNotBeRepeatedlyCharged": "After the upgrade is successful, you can view your upgrade information in the first order of the subscription; At the same time, the automatic deduction of the original subscription will be automatically terminated through the system and will not be repeatedly charged",
	"transSec.OrderNumber": "Order number",
	"transSec.copy": "copy",
	"transSec.TheTimeOfPlacingTheOrder": "The time of placing the order",
	"transSec.PaymentMethods": "Payment Methods",
	"transSec.PaymentTime": "Payment time",
	"transSec.ActualPayment": "Actual Payment:",
	"transSec.DetermineTheUpgrade": "Determine the upgrade",
	"transSec.prompt": "prompt",
	"transSec.GotIt": "Got it",
	"transSec.ToPayForThisOrderPleasePayInTheOrderLogisticsOfTheCallPublicAccount": "To pay for this order, please pay in the order logistics of the [Call] public account",
	"transSec.TheUpgradeRateChangesDueToChangesInTheNumberOfSubscriptionPeriods": "The upgrade rate changes due to changes in the number of subscription periods",
	"transSec.ItemAmount": "Item amount:",
	"transSec.SubscriptionPayment": "Subscription Payment:",
	"transSec.UpgradeOffer": "Upgrade Offer:",
	"transSec.Expenses": "Expenses:",
	"transSec.return": "return",
	"transSec.GoOn": "Go on"
}